<template>
  <div class="archive-image-block">
    <figure
        class="archive-image-block__figure"
    >
      <AppImageFigure :data="computedData" classes="image-figure--full-width" :renditions="renditions"/>
    </figure>
  </div>
</template>
<script setup lang="ts">
import {computed} from 'vue'
import {TImageBlock} from '~/types/block-types'

const props = defineProps<{
  data: TImageBlock,
}>()

// support standard images (instead of focal point images)
const computedData = computed(() => {

  return {
    ...props.data, image: {
      image: props.data.image,
      focalPoints: [
        {
          id: 0,
          x: 50,
          y: 50,
          zoom: 0
        }
      ]
    }
  }
})

const renditions = computed(() => {
  const orientationMultiplier = 0.563

  return [
    {width: 550, height: Math.floor(550 * orientationMultiplier), breakpoint: 'xs'},
    {width: 700, height: Math.floor(700 * orientationMultiplier), breakpoint: 'sm'},
    {width: 800, height: Math.floor(800 * orientationMultiplier), breakpoint: 'md'},
    {width: 900, height: Math.floor(900 * orientationMultiplier), breakpoint: 'lg'},
    {width: 1000, height: Math.floor(1000 * orientationMultiplier), breakpoint: 'xxl'}
  ]
})
</script>

<style scoped lang="postcss">
.archive-image-block {
  @mixin container;
  margin-bottom: 1.5rem;
  @mixin app-container-padding;
  @mixin app-grid;

  @media (--lg) {
    margin-bottom: 2.5rem;
  }

  &__figure {
    grid-column: 1 / -1;

    @media (--xl) {
      grid-column: span 10 / span 10;
      grid-column-start: 2;
    }
  }
}
</style>
